module.exports = __webpack_public_path__ + "static/img/展览.cc84e749.png";